module.exports = __webpack_public_path__ + "static/media/img5.73a034c4.jpg";